module.exports = __webpack_public_path__ + "img/outgoing-call-w.21829be9.svg";